import { Component, OnInit, ChangeDetectionStrategy, ChangeDetectorRef, ViewEncapsulation } from '@angular/core';
import { AutoSub, AutoSubOnDestroy } from '../../providers';
import { Animations } from '../../animations';
import { Toast, ToastService, ToastType } from '../../providers/toast.service';

@AutoSubOnDestroy()
@Component({
    selector: 'motes-toast',
    templateUrl: './toast.component.html',
    styleUrls: ['./toast.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    animations: [Animations.fadeIn(200), Animations.shrinkVertical(200)]
})

export class ToastComponent implements OnInit {

    constructor(private toastService: ToastService, private cd: ChangeDetectorRef) { }

    public toasts: Toast[] = [];

    // Expose to view
    public ToastType = ToastType;

    ngOnInit() {
        AutoSub(this).reg['toastSub'] = this.toastService.watchToast().subscribe((toasts) => {
            this.toasts = toasts;
            this.cd.markForCheck();
        });
    }

    public hideToast(toast: Toast, idx: number) {
        // Ignore hide request if close is not enabled
        if(!toast?.showCloseOption) return;
        this.toasts.splice(idx, 1);
    }

    public invokeToastAction(toast: Toast) {
        toast.action.callback();
    }
}
